<template>
    <v-container fluid>
      <v-card>
        <v-card-title>Configuracion Tasas</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="12" md="2">
              <v-text-field
                v-model="iva"
                label="Porc. de IVA"
                hide-details
                type="number"
                prepend-icon="mdi-percent"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="2">
              <v-text-field
                v-model="extracargos"
                label="Porc. adicional Extracargos"
                hide-details
                type="number"
                prepend-icon="mdi-percent"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="2">
              <v-text-field
                v-model="porc_seguro"
                label="Porc. Seguro"
                hide-details
                type="number"
                prepend-icon="mdi-percent"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="2">
              <v-text-field
                v-model="valor_minimo_seguro"
                label="Costo Minimo Seguro"
                hide-details
                type="number"
                prepend-icon="mdi-currency-usd"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="2">
              <v-text-field
                v-model="porc_fs"
                label="Porc. Fuel Surcharge"
                hide-details
                type="number"
                prepend-icon="mdi-percent"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="2">
              <v-text-field
                v-model="t_peso_mayor_a"
                label="Peso Minimo para Corte de Guía (KG)"
                hide-details
                type="number"
                prepend-icon="mdi-weight-kilogram"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="2">
              <v-text-field
                v-model="t_valor_mayor_a"
                label="Valor Minimo para Corte Guía ($)"
                hide-details
                type="number"
                prepend-icon="mdi-currency-usd"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="2">
              <v-text-field
                v-model="t_valor_corte"
                label="Costo Corte Guía"
                hide-details
                type="number"
                prepend-icon="mdi-currency-usd"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer><v-btn outlined color="primary" @click="actualizar()"> Actualizar </v-btn>
        </v-card-actions>
      </v-card>
      <v-overlay :value="overlay">
          <waiting />
      </v-overlay>
    </v-container>
  </template>

  <script>
  import apicon from '../plugins/apicon';
  import Waiting from '../components/Waiting.vue';
  export default {
    components:{
      Waiting
    },
    created: function () {},
    data() {
      return {
        iva: null,
        extracargos: null,
        porc_seguro: null,
        valor_minimo_seguro: null,
        porc_fs: null,
        t_peso_mayor_a: null,
        t_valor_mayor_a: null,
        t_valor_corte: null,
        almacenaje: null,
        overlay: false,
      };
    },
    methods: {
      getData: async function(){
        await apicon.getDataApi(apicon.getApiBaseUrl() + 'gettasas').then((result) => {
          this.iva = result.iva.iva;
          this.extracargos = result.porcExtracargos.porcentaje;
          this.porc_seguro = result.porcSeguro.porcentaje;
          this.valor_minimo_seguro = result.porcSeguro.valor_minimo;
          this.porc_fs = result.porcFS.porcentaje;
          this.t_peso_mayor_a = result.tasaCorteGuia.peso_mayor_a;
          this.t_valor_mayor_a = result.tasaCorteGuia.valor_mayor_a;
          this.t_valor_corte = result.tasaCorteGuia.valor_corte;
        });
      },
      actualizar: async function(){
        await apicon.updateDataApi(apicon.getApiBaseUrl() + 'updtasas', {
          iva: {iva : this.iva},
          porcExtracargos: {porcentaje: this.extracargos},
          porcSeguro: {porcentaje: this.porc_seguro, valor_minimo: this.valor_minimo_seguro},
          porcFS: {porcentaje : this.porc_fs},
          tasaCorteGuia: {peso_mayor_a: this.t_peso_mayor_a, valor_mayor_a  : this.t_valor_mayor_a, valor_corte : this.t_valor_corte}
        }).then((result) => {
          this.$swal(result.message);
        })
      }

    },
    mounted:async function () {
      await apicon.setAuthHeaders();
      await this.getData();
    },
  };
  </script>
